<template>
  <div>
    <div v-if="!this.formulaReady" class="loaderContainer">
      <dot-loader></dot-loader>
    </div>
    <span class="no-data" v-if="noData && formulaReady">Keine Daten vorhanden</span>
    <grid-layout ref="gridLayout" v-if="formulaReady && layoutReady && !noData"
                 :layout.sync="layout"
                 :is-draggable="this.isEditable"
                 :is-mirrored="false"
                 :prevent-collision="false"
                 :vertical-compact="false"
                 :autoSize="true"
                 :margin="[15, 15]"
                 :row-height="calcColWidth"
                 class="gridLayout"
                 @layout-updated="afterMovedCorrection"
                 :is-resizable="false"
                 :responsive="false"
                 :use-css-transforms="false"
                 :colNum="colNum"
    >
      <grid-item v-if="(findInLayout('Interaction Rate').visibility === 'extern' || isEditable )&& layoutReady"
                 :fixed="true"
                 :x="findInLayout('Interaction Rate').x"
                 :y="findInLayout('Interaction Rate').y"
                 :w="findInLayout('Interaction Rate').w"
                 :h="findInLayout('Interaction Rate').h"
                 :i="findInLayout('Interaction Rate').i"
                 :key="'draggable-'+findInLayout('Interaction Rate').i">
        <div class="chart">
          <div class="chart-header"><span
              class="chart-header-text">{{ 'Interaction Rate (' + getInteractionRate + ')' }}</span>
            <ChartActionBar :editable="this.isEditable"
                            @showComment="editComment('Interaction Rate')"
                            :visibility="findInLayout('Interaction Rate').visibility"
                            :comment="findInLayout('Interaction Rate').comment"
                            :width="findInLayout('Interaction Rate').w"
                            @toggleVisibility="toggleVisibility('Interaction Rate')"
                            @resize="resizeChartGridItem('Interaction Rate')"></ChartActionBar>
          </div>
          <BarChart class="chart-wrapper" :width="calcColWidth*2"
                    :height="calcColWidth*0.8"
                    title="Interactions"
                    :labels="['INTERNE KLICKS', 'EXTERNE KLICKS', 'MOUSEOVER', 'SONSTIGE']"
                    :data="[getInternalClicks, getExternalClicks, getMouseOver, getOther]"
                    :percentages="[getInternalClicksRelation, getExternalClicksRelation, getOtherRelation]"
                    :interactionRate="getInteractionRate" type="big"></BarChart>
        </div>
      </grid-item>
      <grid-item v-if="(findInLayout('Gesamt-Klickrate').visibility === 'extern' || isEditable) && layoutReady"
                 :fixed="true"
                 :x="findInLayout('Gesamt-Klickrate').x"
                 :y="findInLayout('Gesamt-Klickrate').y"
                 :w="findInLayout('Gesamt-Klickrate').w"
                 :h="findInLayout('Gesamt-Klickrate').h"
                 :i="findInLayout('Gesamt-Klickrate').i"
                 :key="'draggable-'+findInLayout('Gesamt-Klickrate').i">
        <div class="chart">
          <div class="chart-header"><span class="chart-header-text">Gesamt-Klickrate</span>
            <ChartActionBar :editable="this.isEditable"
                            @showComment="editComment('Gesamt-Klickrate')"
                            :visibility="findInLayout('Gesamt-Klickrate').visibility"
                            :comment="findInLayout('Gesamt-Klickrate').comment"
                            @toggleVisibility="toggleVisibility('Gesamt-Klickrate')"
                            :resizeAllowed="false"></ChartActionBar>
          </div>
          <PieChart class="chart-wrapper" :labels="['externe Klicks', 'interne Klicks']"
                    :data="[getExternalClicks, getInternalClicks]"
                    center-title="Gesamt" :center-text="getTotalClickRate"
                    :height="calcColWidth*0.8" :width="calcColWidth*0.8"></PieChart>
        </div>
      </grid-item>
      <grid-item v-if="(findInLayout('Interaction Time').visibility === 'extern' || isEditable) && layoutReady"
                 :fixed="true"
                 :x="findInLayout('Interaction Time').x"
                 :y="findInLayout('Interaction Time').y"
                 :w="findInLayout('Interaction Time').w"
                 :h="findInLayout('Interaction Time').h"
                 :i="findInLayout('Interaction Time').i"
                 :key="'draggable-'+findInLayout('Interaction Time').i">
        <div class="chart">
          <div class="chart-header"><span class="chart-header-text">Interaction Time</span>
            <ChartActionBar :editable="this.isEditable"
                            @showComment="editComment('Interaction Time')"
                            :visibility="findInLayout('Interaction Time').visibility"
                            :comment="findInLayout('Interaction Time').comment"
                            @toggleVisibility="toggleVisibility('Interaction Time')"
                            :resizeAllowed="false"></ChartActionBar>
          </div>
          <GaugeChart class="chart-wrapper" :text="'Ø '+getInteractionTime+' s'" :max-value="15"
                      :percentage="getHeavyUser"
                      :value="getInteractionTime" details="Heavy User (> 15s)"
                      :width="calcColWidth*0.6"></GaugeChart>
        </div>
      </grid-item>
      <grid-item
          v-if="(findInLayout('Interaktiver MouseOver-Rate').visibility === 'extern' || isEditable) && layoutReady"
          :fixed="true"
          :x="findInLayout('Interaktiver MouseOver-Rate').x"
          :y="findInLayout('Interaktiver MouseOver-Rate').y"
          :w="findInLayout('Interaktiver MouseOver-Rate').w"
          :h="findInLayout('Interaktiver MouseOver-Rate').h"
          :i="findInLayout('Interaktiver MouseOver-Rate').i"
          :key="'draggable-'+findInLayout('Interaktiver MouseOver-Rate').i">
        <div class="chart">
          <div class="chart-header"><span
              class="chart-header-text">{{
              'Interaction Rate exkl. MouseOvers (' + getInteractionRate + ')'
            }}</span>
            <ChartActionBar :editable="this.isEditable"
                            @showComment="editComment('Interaktiver MouseOver-Rate')"
                            :visibility="findInLayout('Interaktiver MouseOver-Rate').visibility"
                            :comment="findInLayout('Interaktiver MouseOver-Rate').comment"
                            @toggleVisibility="toggleVisibility('Interaktiver MouseOver-Rate')"
                            :width="findInLayout('Interaktiver MouseOver-Rate').w"
                            @resize="resizeChartGridItem('Interaktiver MouseOver-Rate')"></ChartActionBar>
          </div>
          <BarChart class="chart-wrapper" :width="calcColWidth*2"
                    :height="calcColWidth*0.8"
                    title="Interactions"
                    :labels="['INTERNE KLICKS', 'EXTERNE KLICKS', 'SONSTIGE']"
                    :data="[getInternalClicks, getExternalClicks, getOther]"
                    :percentages="[getInternalClicksRelation, getExternalClicksRelation, getOtherRelation]"
                    :interactionRate="getInteractionRate" type="big"></BarChart>
        </div>
      </grid-item>
      <grid-item v-for="(item,index) in expandTimes"
                 :fixed="true"
                 :x="findInLayout('expand_sum-'+index).x"
                 :y="findInLayout('expand_sum-'+index).y"
                 :w="findInLayout('expand_sum-'+index).w"
                 :h="findInLayout('expand_sum-'+index).h"
                 :i="findInLayout('expand_sum-'+index).i"
                 :key="'draggable-expand-'+index">
        <div class="chart">
          <div class="chart-header"><span
              class="chart-header-text">{{ 'Expand Time (Slot ' + (index + 1) + ')' }}</span>
            <ChartActionBar :editable="isEditable" @showComment="editComment('expand_sum-'+index)"
                            :comment="findInLayout('expand_sum-'+index).comment"
                            :visibility="findInLayout('expand_sum-'+index).visibility"
                            @toggleVisibility="toggleVisibility('expand_sum-'+index)"
                            :resizeAllowed="false"></ChartActionBar>
          </div>
          <GaugeChart class="chart-wrapper" :text="'Ø '+this.getCount(item['Expand Time'])"
                      :max-value="10"
                      :percentage="typeof item['Heavy User im Expand'] !== 'undefined' ? getRelation(item['Heavy User im Expand'])+' ('+getCount(item['Heavy User im Expand'])+' AI)':''"
                      :value="getCount(item['Expand Time'])"
                      details="Heavy User (> 10s)"
                      :width="calcColWidth*0.6"></GaugeChart>
        </div>
      </grid-item>
      <grid-item v-for="(item,index) in videos"
                 :fixed="true"
                 :x="findInLayout('video_sum-'+index).x"
                 :y="findInLayout('video_sum-'+index).y"
                 :w="findInLayout('video_sum-'+index).w"
                 :h="findInLayout('video_sum-'+index).h"
                 :i="findInLayout('video_sum-'+index).i"
                 :key="'draggable-video-'+index">
        <div class="chart">
          <div class="chart-header"><span
              class="chart-header-text">{{ 'Video ' + (index + 1) + ' Views' }}</span>
            <ChartActionBar :editable="isEditable" @showComment="editComment('video_sum-'+index)"
                            :comment="findInLayout('video_sum-'+index).comment"
                            :visibility="findInLayout('video_sum-'+index).visibility"
                            @toggleVisibility="toggleVisibility('video_sum-'+index)"
                            :width="findInLayout('video_sum-'+index).w"
                            @resize="resizeChartGridItem('video_sum-'+index)"></ChartActionBar>
          </div>
          <LineChart class="chart-wrapper" :width="calcColWidth*2" :height="calcColWidth*0.8"
                     :labels="getVideoLabels(item)" :data="getVideoValues(item)"></LineChart>
        </div>
      </grid-item>
    </grid-layout>
    <!--<Dialog custom-styles="padding:2.1rem" :has-backdrop="true" :show="showDialog" @close="dialogClosed"
            :show-close-button="true">
        <textarea class="textarea-comment" rows="8" v-model="textAreaSingleComment" maxlength="300"></textarea>
    </Dialog>-->
    <Confirm title="Hinweis bearbeiten" :show="showDialog" @close="showDialog = false;"
             @onok="confirmComment" @oncancel="deleteComment" :options="{confirm:{
                        title: 'Bestätigen',
                        icon: 'icon-apply'
                    },
                    cancel:{
                        title: 'Löschen',
                        icon: 'icon-delete'
                    }}">
      <textarea class="textarea-comment" rows="8" v-model="textAreaSingleComment" maxlength="300"></textarea>
    </Confirm>
  </div>
</template>

<script>
import {RepositoryFactory} from "../../scripts/RepositoryFactory";
import BarChart from "../../components/charts/BarChart";
import PieChart from "../../components/charts/PieChart";
import GaugeChart from "../../components/charts/GaugeChart";
import ChartActionBar from "./ChartActionBar";
import VueGridLayout from 'vue-grid-layout';
import LineChart from "../../components/charts/LineChart";
import Confirm from "../../components/dialog/Confirm";

const TrackingListRepository = RepositoryFactory.get('trackingLists');
const CampaignRepository = RepositoryFactory.get('campaigns');

export default {
  name: "ChartGrid",
  components: {
    Confirm,
    LineChart,
    ChartActionBar,
    GaugeChart,
    PieChart,
    BarChart,
    GridLayout: VueGridLayout.GridLayout,
    GridItem: VueGridLayout.GridItem
  },
  data() {
    return {
      layoutReady: false,
      showDialog: false,
      layout: [],
      colNum: 9,
      allLayouts: [],
      layoutMatrix: [],
      textAreaSingleComment: '',
      textAreaSingleCommentIndex: -1,
      currentBreakPoint: 'lg',
      noData: false,
      validCharts: ['Interaction Rate', 'Gesamt-Klickrate', 'Interaction Time', 'Interaktiver MouseOver-Rate', 'expand_sum', 'video_sum'],
      fnSaveDashboard: null,
      fnSaveDashboardHeader: null,
      localFormulas: []
    }
  },
  props: {
    formulaReady: {
      type: Boolean,
      default: false
    },
    formulas: {
      type: Array,
      required: true
    },
    engagementHash: {
      type: String,
      required: true
    },
    isEditable: {
      type: Boolean,
      default: false
    },
    comment: {
      type: String,
      default: ''
    },
    sites: {
      type: Array,
      required: true
    },
    insertionOrderIndex: {
      type: Number,
      required: true
    },
    mediumIndex: {
      type: Number,
      required: true
    },
  },
  mounted() {
    this.localFormulas = JSON.parse(JSON.stringify(this.formulas));
    this.fnSaveDashboard = () => {
      this.saveDashboard(false);
    };
    this.fnSaveDashboardHeader = () => {
      this.saveDashboard(true);
    };
    this.$root.$on('saveDashboard', this.fnSaveDashboard);
    this.$root.$on('saveDashboardHeader', this.fnSaveDashboardHeader);
    if (this.formulaReady) {
      this.updateLayout();
    }
  },
  beforeDestroy() {
    this.$root.$off('saveDashboard', this.fnSaveDashboard);
    this.$root.$off('saveDashboardHeader', this.fnSaveDashboardHeader);
  },
  computed: {
    vuexStateComment() {
      return this.$store.state.campaign.campaign.comment;
    },
    insertionOrder() {
      return this.$store.state.campaign.campaign.mediums[this.mediumIndex].insertion_order[this.insertionOrderIndex];
    },
    campaignId() {
      return this.$store.state.campaign.campaign.id;
    },
    getTotalClickRate() {
      let reporting = this.getReporting('gesamt-klickrate');
      return !reporting ? '0.00 %' : reporting.relation;
    },
    calcColWidth() {
      let colNum = 9;
      if (this.currentBreakPoint === 'xs' || this.currentBreakPoint === 'xxs') {
        colNum = 3;
      } else if (this.currentBreakPoint === 'sm' || this.currentBreakPoint === 'md') {
        colNum = 6;
      }
      let width = window.innerWidth > 1400 ? 1400 : window.innerWidth;
      let colWidth = (width - (15 * (colNum + 1))) / colNum;
      colWidth = colWidth * 3 + 30;
      //   colWidth = colNum === 3 ? colWidth+30 : (colNum === 2 ? colWidth+15 : colWidth);
      //colWidth = colNum === 3 ? colWidth+30 : (colNum === 2 ? colWidth+15 : colWidth);
      return colWidth;
    },
    getInteractionRate() {
      let reporting = this.getReporting('interaction rate');
      return !reporting ? '0.00 %' : reporting.relation;
    },
    getInternalClicks() {
      let reporting = this.getReporting('interne klickrate');
      return !reporting ? '0' : reporting.count;
    },
    getInternalClicksRelation() {
      let reporting = this.getReporting('interne klickrate');
      return !reporting ? '0' : reporting.relation;
    },
    getExternalClicksRelation() {
      let reporting = this.getReporting('externe klickrate');
      return !reporting ? '0' : reporting.relation;
    },
    getExternalClicks() {
      let reporting = this.getReporting('externe klickrate');
      return !reporting ? '0' : reporting.count;
    },
    getMouseOver() {
      let reporting = this.getReporting('interaktiver mouseover-rate');
      return !reporting ? '0' : reporting.count;
    },
    getHeavyUser() {
      let reporting = this.getReporting('heavy user');
      return !reporting ? '0.00 %' : reporting.relation;
    },
    getOther() {
      let reportingSwipes = this.getReporting('swipes');
      reportingSwipes = !reportingSwipes ? '0' : reportingSwipes.count;
      let reportingDrags = this.getReporting('drags');
      reportingDrags = !reportingDrags ? '0' : reportingDrags.count;
      let reportingScrolls = this.getReporting('scrolls');
      reportingScrolls = !reportingScrolls ? '0' : reportingScrolls.count;
      return reportingSwipes + reportingScrolls + reportingDrags;
    },
    getOtherRelation() {
      let reportingSwipes = this.getReporting('swipes');
      reportingSwipes = !reportingSwipes ? 0 : parseFloat(reportingSwipes.relation.replace('%', ''));
      let reportingDrags = this.getReporting('drags');
      reportingDrags = !reportingDrags ? 0 : parseFloat(reportingDrags.relation.replace('%', ''));
      let reportingScrolls = this.getReporting('scrolls');
      reportingScrolls = !reportingScrolls ? 0 : parseFloat(reportingScrolls.relation.replace('%', ''));
      return (reportingSwipes + reportingScrolls + reportingDrags) / 3 + '%';
    },
    getInteractionTime() {
      let reporting = this.getReporting('interaction time');
      reporting = parseFloat(reporting.count.replace(',', '.'));
      return reporting;
    },
    expandTimes() {
      let formulas = [];
      let count = 0;
      for (let i = 0; i < this.formulas.length; i++) {
        if (this.formulas[i].name === 'expand_sum' && typeof this.formulas[i]['Expand Time'] !== 'undefined' && (this.findInLayout('expand_sum-' + count).visibility === 'extern' || this.isEditable) && this.layoutReady) {
          formulas.push(this.formulas[i]);
          count++;
        }
      }
      return formulas;
    },
    videos() {
      let formulas = [];
      let count = 0;
      for (let i = 0; i < this.formulas.length; i++) {
        if (this.formulas[i].name === 'video_sum' && (this.findInLayout('video_sum-' + count).visibility === 'extern' || this.isEditable) && this.layoutReady) {
          formulas.push(this.formulas[i]);
          count++;
        }
      }
      return formulas;
    }
  },
  watch: {
    formulaReady: function () {
      this.localFormulas = JSON.parse(JSON.stringify(this.formulas));
      this.updateLayout()
    }
  },
  created() {
    this.getCurrentBreakpoint();
    window.addEventListener('resize', this.getCurrentBreakpoint);
  },
  destroyed() {
    window.removeEventListener('resize', this.getCurrentBreakpoint);
  },
  methods: {
    getReporting(name) {
      let hash_key = this.engagementHash + '_' + this.insertionOrder.id;
      for (let index = 0; index < this.formulas.length; index++) {
        if (this.formulas[index].name.toLowerCase() === name.toLowerCase()) {
          if (typeof this.formulas[index].reporting[hash_key] !== 'undefined' && this.formulas[index].reporting[hash_key].sites.length > 0) {
            this.noData = false;
            return this.formulas[index].reporting[hash_key].sites[this.insertionOrderIndex];
          } else {
            this.noData = true;
            break;
          }
        }
      }
      return {
        relation: 0,
        count: 0
      };
    },
    resizeChartGridItem(name) {
      let videoCount = 0;
      for (let i = 0; i < this.layout.length; i++) {
        let nameTrue = false;
        if (this.layout[i].name === 'video_sum') {
          if (this.layout[i].name + '-' + videoCount === name) {
            nameTrue = true;
          } else {
            videoCount++;
          }
        } else if (this.layout[i].name === name) {
          nameTrue = true;
        }
        if (nameTrue) {
          if (this.layout[i].w === 3) {
            if (this.layout[i].x === 6) {
              this.layoutMatrix[this.layout[i].y][this.layout[i].x / 3] = -1;
              this.layoutMatrix = this.moveRightFromPosition(this.layoutMatrix, 0, this.layout[i].y + 1, 2);
              this.layoutMatrix = this.correctMatrix(this.layoutMatrix);
              this.syncMatrixWithLayoutReverse();
              this.layout[i].x = 0;
              this.layout[i].y = this.layout[i].y + 1;
              this.layout[i].w = 6;
            } else {
              this.layoutMatrix = this.moveRightFromPosition(this.layoutMatrix, this.layout[i].x / 3 + 1, this.layout[i].y, 1);
              this.layoutMatrix = this.correctMatrix(this.layoutMatrix);
              this.syncMatrixWithLayoutReverse();
              this.layout[i].w = 6;
            }
            this.layoutMatrix[this.layout[i].y][this.layout[i].x / 3] = this.layout[i].i;
            this.layoutMatrix[this.layout[i].y][this.layout[i].x / 3 + 1] = this.layout[i].i;
          } else {
            this.layout[i].w = 3;
            this.layoutMatrix[this.layout[i].y][this.layout[i].x / 3 + 1] = -1;
          }

          let index = this.findIndexInFormulas(this.layout[i].i);
          this.localFormulas[index].pivot.chart_width = this.layout[i].w;
          this.verticalCompact();
        }
      }
    },
    toggleVisibility(name) {
      let expandCount = 0;
      let videoCount = 0;
      for (let i = 0; i < this.layout.length; i++) {
        if (this.layout[i].name === 'expand_sum') {
          if (this.layout[i].name + '-' + expandCount === name) {
            this.layout[i].visibility = this.layout[i].visibility === "intern" ? "extern" : "intern";
            this.localFormulas[this.findIndexInFormulas(this.layout[i].i)].pivot.visibility = this.layout[i].visibility;
            break;
          } else {
            expandCount++;
          }
        } else if (this.layout[i].name === 'video_sum') {
          if (this.layout[i].name + '-' + videoCount === name) {
            this.layout[i].visibility = this.layout[i].visibility === "intern" ? "extern" : "intern";
            this.localFormulas[this.findIndexInFormulas(this.layout[i].i)].pivot.visibility = this.layout[i].visibility;
            break;
          } else {
            videoCount++;
          }
        } else if (this.layout[i].name === name) {
          this.layout[i].visibility = this.layout[i].visibility === "intern" ? "extern" : "intern";
          this.localFormulas[this.layout[i].i].pivot.visibility = this.layout[i].visibility;
          break;
        }
      }
    },
    updateLayout() {
      this.layoutReady = false;
      this.layout = [];
      this.layoutMatrix = [];
      let expandCount = 0;
      let videoCount = 0;
      for (let k = 0; k < this.formulas.length; k++) {
        if (this.validCharts.indexOf(this.formulas[k].name) !== -1 && (this.isEditable || this.formulas[k].pivot.visibility === 'extern')) {
          if (this.formulas[k].name === 'expand_sum' && typeof this.formulas[k]['Expand Time'] === 'undefined') {
            continue;
          }
          if (this.formulas[k].pivot.chart_width === 6) {
            if (this.formulas[k].pivot.position_x / 3 !== 2) {

              if (typeof this.layoutMatrix[this.formulas[k].pivot.position_y] === 'undefined') {
                this.layoutMatrix[this.formulas[k].pivot.position_y] = new Array(3).fill(-1);
              }
              if (this.layoutMatrix[this.formulas[k].pivot.position_y][this.formulas[k].pivot.position_x / 3] === -1 &&
                  this.layoutMatrix[this.formulas[k].pivot.position_y][(this.formulas[k].pivot.position_x / 3) + 1] === -1) {
                let iNum = 0;
                if (this.formulas[k].name === 'expand_sum') {
                  iNum = 'e-' + this.formulas[k].id + '-' + expandCount;
                  expandCount++;
                } else if (this.formulas[k].name === 'video_sum') {
                  iNum = 'v-' + this.formulas[k].id + '-' + videoCount;
                  videoCount++;
                } else {
                  iNum = this.formulas[k].id;
                }
                this.layoutMatrix[this.formulas[k].pivot.position_y][this.formulas[k].pivot.position_x / 3] = iNum;
                this.layoutMatrix[this.formulas[k].pivot.position_y][(this.formulas[k].pivot.position_x / 3) + 1] = iNum;
              }
            }

          } else {
            if (typeof this.layoutMatrix[this.formulas[k].pivot.position_y] === 'undefined') {
              this.layoutMatrix[this.formulas[k].pivot.position_y] = new Array(3).fill(-1);
            }
            if (this.layoutMatrix[this.formulas[k].pivot.position_y][this.formulas[k].pivot.position_x / 3] === -1) {
              let iNum = 0;
              if (this.formulas[k].name === 'expand_sum') {
                iNum = 'e-' + this.formulas[k].id + '-' + expandCount;
                expandCount++;
              } else if (this.formulas[k].name === 'video_sum') {
                iNum = 'v-' + this.formulas[k].id + '-' + videoCount;
                videoCount++;
              } else {
                iNum = this.formulas[k].id;
              }
              this.layoutMatrix[this.formulas[k].pivot.position_y][this.formulas[k].pivot.position_x / 3] = iNum;
            }
          }
        }
      }

      if (this.currentBreakPoint === 'xs' || this.currentBreakPoint === 'xxs') {
        this.colNum = 3;
        this.layoutMatrix = this.transformMatrix(1);
      } else if (this.currentBreakPoint === 'sm' || this.currentBreakPoint === 'md') {
        this.layoutMatrix = this.transformMatrix(2);
        this.colNum = 6;
      }
      this.syncMatrixWithFormulas();
      this.loadLayout();
      this.layoutReady = true;
    },
    loadLayout() {
      let expandCount = 0;
      let videoCount = 0;
      let layout = [];
      for (let i = 0; i < this.formulas.length; i++) {
        if (this.validCharts.indexOf(this.formulas[i].name) !== -1 && (this.isEditable || this.formulas[i].pivot.visibility === 'extern')) {
          let x = this.formulas[i].pivot.position_x / 3;
          let y = this.formulas[i].pivot.position_y;
          let iNum = 0;
          if (this.formulas[i].name === 'expand_sum') {
            iNum = 'e-' + this.formulas[i].id + '-' + expandCount;
            expandCount++;
          } else if (this.formulas[i].name === 'video_sum') {
            iNum = 'v-' + this.formulas[i].id + '-' + videoCount;
            videoCount++;
          } else {
            iNum = this.formulas[i].id;
          }
          if (this.layoutMatrix[y][x] !== iNum) {

            let positions = this.nextFreeMatrixPos(x, y, this.formulas[i].pivot.chart_width, iNum);
            x = positions.x;
            y = positions.y;
          }
          layout.push({
            "name": this.formulas[i].name,
            "x": x * 3,
            "y": y,
            "w": (this.currentBreakPoint === 'xs' || this.currentBreakPoint === 'xxs') ? 3 : this.formulas[i].pivot.chart_width,
            "h": 1,
            "i": iNum,
            "visibility": this.formulas[i].pivot.visibility,
            "comment": this.formulas[i].pivot.comment
          })
        }
      }
      this.layout = layout;
    },
    findIndexInLayout(name) {
      let expandCount = 0;
      let videoCount = 0;
      for (let i = 0; i < this.layout.length; i++) {
        if (this.layout[i].name === 'expand_sum') {
          if (this.layout[i].name + '-' + expandCount === name) {
            return i;
          } else {
            expandCount++;
          }
        } else if (this.layout[i].name === 'video_sum') {
          if (this.layout[i].name + '-' + videoCount === name) {
            return i;
          } else {
            videoCount++;
          }
        } else if (this.layout[i].name === name) {
          return i;
        }
      }
      return false;
    },
    findInLayout(name) {
      let expandCount = 0;
      let videoCount = 0;
      for (let i = 0; i < this.layout.length; i++) {
        if (this.layout[i].name === 'expand_sum') {
          if (this.layout[i].name + '-' + expandCount === name) {
            return this.layout[i];
          } else {
            expandCount++;
          }
        } else if (this.layout[i].name === 'video_sum') {
          if (this.layout[i].name + '-' + videoCount === name) {
            return this.layout[i];
          } else {
            videoCount++;
          }
        } else if (this.layout[i].name === name) {
          return this.layout[i];
        }
      }
      return {};
    },
    findLayoutIndexById(id) {
      for (let i = 0; i < this.layout.length; i++) {
        if (this.layout[i].i === id) {
          return i;
        }
      }
      return {};
    },
    nextFreeMatrixPos(x, y, w, id) {
      if (w === 3 || this.currentBreakPoint === 'xs' || this.currentBreakPoint === 'xxs') {
        for (let i = 0; i < this.layoutMatrix.length; i++) {
          for (let j = 0; j < this.layoutMatrix[i].length; j++) {
            if (this.layoutMatrix[i][j] === -1) {
              this.layoutMatrix[i][j] = id;
              return {y: i, x: j};
            }
          }
        }
      } else {
        let filled = false;
        let tmpI = 0;
        let tmpJ = 0;
        while (!filled) {
          if (tmpJ === this.layoutMatrix.length) {
            this.layoutMatrix[this.layoutMatrix.length] = new Array(3).fill(-1);
            this.layoutMatrix[this.layoutMatrix.length - 1][0] = id;
            this.layoutMatrix[this.layoutMatrix.length - 1][1] = id;
            filled = true;
            return {x: 0, y: this.layoutMatrix.length - 1};
          }
          if (this.layoutMatrix[tmpI][tmpJ] === -1 && this.layoutMatrix[tmpI][tmpJ + 1] === -1) {
            this.layoutMatrix[tmpI][tmpJ] = id;
            this.layoutMatrix[tmpI][tmpJ + 1] = id;
            filled = true;
            return {x: tmpJ, y: tmpI};
          }
          tmpJ++;
          if (tmpJ === 2) {
            tmpJ = 0;
            tmpI++;
          }

        }
      }
      if (this.currentBreakPoint === 'xs' || this.currentBreakPoint === 'xxs') {
        this.layoutMatrix[this.layoutMatrix.length] = new Array(1).fill(-1);
      } else if (this.currentBreakPoint === 'sm' || this.currentBreakPoint === 'md') {
        this.layoutMatrix[this.layoutMatrix.length] = new Array(2).fill(-1);
      } else {
        this.layoutMatrix[this.layoutMatrix.length] = new Array(3).fill(-1);
      }
      this.layoutMatrix[this.layoutMatrix.length - 1][0] = id;
      return {x: 0, y: this.layoutMatrix.length - 1};
    },
    afterMovedCorrection() {
      if (this.currentBreakPoint === 'lg') {
        this.clearLayoutMatrix();
        for (let i = 0; i < this.layout.length; i++) {
          if (this.layout[i].x < 3) {
            this.layout[i].x = 0;
          } else if (this.layout[i].x >= 3 && this.layout[i].x < 6) {
            this.layout[i].x = 3;
          } else {
            this.layout[i].x = 6;
          }
          if (typeof this.layoutMatrix[this.layout[i].y] === 'undefined') {
            this.layoutMatrix[this.layout[i].y] = new Array(3).fill(-1);
          }
          this.layoutMatrix[this.layout[i].y][this.layout[i].x / 3] = this.layout[i].i;
          if (this.layout[i].w === 6) {
            this.layoutMatrix[this.layout[i].y][this.layout[i].x / 3 + 1] = this.layout[i].i;
          }
        }
        for (let j = 0; j < this.layoutMatrix.length; j++) {
          if (typeof this.layoutMatrix[j] === 'undefined') {
            this.layoutMatrix[j] = new Array(3).fill(-1);
          }
        }
        this.verticalCompact();
      }

    },
    clearLayoutMatrix() {
      for (let i = 0; i < this.layoutMatrix.length; i++) {
        if (typeof this.layoutMatrix[i] !== 'undefined') {
          for (let j = 0; j < this.layoutMatrix[i].length; j++) {
            this.layoutMatrix[i][j] = -1;
          }
        }

      }
    },
    verticalCompact() {
      for (let i = 0; i < this.layoutMatrix.length; i++) {
        for (let j = 0; j < this.layoutMatrix[i].length; j++) {
          if (this.layoutMatrix[i][j] === -1) {
            let nextFilled = this.findNextFilled(j, i);
            if (!nextFilled) {
              break;
            }
            let index = this.findLayoutIndexById(nextFilled.id);
            if (this.layout[index].w === 3) {
              this.layoutMatrix[i][j] = nextFilled.id;
              this.layoutMatrix[nextFilled.y][nextFilled.x] = -1;
              this.layout[index].y = i;
              this.layout[index].x = j * 3;
            } else if (j * 3 !== 6) {
              this.layoutMatrix[i][j] = nextFilled.id;
              this.layoutMatrix[nextFilled.y][nextFilled.x] = -1;
              this.layoutMatrix[i][j + 1] = nextFilled.id;
              this.layoutMatrix[nextFilled.y][nextFilled.x + 1] = -1;
              this.layout[index].y = i;
              this.layout[index].x = j * 3;
            }
          }
        }
      }
    },
    findNextFilled(x, y) {
      let xPos = x;
      let yPos = y;
      while (yPos !== this.layoutMatrix.length) {
        if (this.layoutMatrix[yPos][xPos] !== -1) {
          return {x: xPos, y: yPos, id: this.layoutMatrix[yPos][xPos]}
        }
        xPos++;
        if (xPos >= this.layoutMatrix[yPos].length) {
          yPos++;
          xPos = 0;
        }
      }
      return false;
    },
    editComment: function (formulaName) {
      let index = this.findIndexInLayout(formulaName);
      if (index !== false) {
        this.textAreaSingleCommentIndex = index;
        this.textAreaSingleComment = typeof this.layout[index].comment !== 'undefined' ? this.layout[index].comment : '';
        this.showDialog = true;
      }


    },
    confirmComment: function () {
      this.showDialog = false;
      if (this.textAreaSingleCommentIndex !== -1) {
        this.layout[this.textAreaSingleCommentIndex].comment = this.textAreaSingleComment;
      }

    },
    deleteComment: function () {
      this.showDialog = false;
      if (this.textAreaSingleCommentIndex !== -1) {
        this.layout[this.textAreaSingleCommentIndex].comment = '';
      }

    },
    moveRightFromPosition(layoutMatrix, x, y, num) {

      for (let i = 0; i < num; i++) {
        let yPos = y;
        let xPos = x;
        if (i !== 0) {
          xPos++;
          if (xPos > layoutMatrix[0].length - 1) {
            yPos++;
            if (typeof layoutMatrix[yPos] === 'undefined') {
              layoutMatrix[yPos] = new Array(layoutMatrix[0].length).fill(-1);
            }
            xPos = xPos - layoutMatrix[0].length;
          }
        }

        let valueCache = null;
        while (valueCache !== -1) {
          let nextX = xPos + 1;
          let nextY = yPos;
          if (nextX > layoutMatrix[0].length - 1) {
            nextY++;
            if (typeof layoutMatrix[nextY] === 'undefined') {
              layoutMatrix[nextY] = new Array(layoutMatrix[0].length).fill(-1);
            }
            nextX = nextX - layoutMatrix[0].length;
          }
          if (valueCache !== null) {
            let tmp = layoutMatrix[nextY][nextX];
            layoutMatrix[nextY][nextX] = valueCache;
            valueCache = tmp;
          } else {
            valueCache = layoutMatrix[nextY][nextX];
            layoutMatrix[nextY][nextX] = layoutMatrix[yPos][xPos];
            layoutMatrix[yPos][xPos] = -1
          }
          xPos++;
          if (xPos > layoutMatrix[0].length - 1) {
            xPos = 0;
            yPos++;
            if (typeof layoutMatrix[yPos] === 'undefined') {
              layoutMatrix[yPos] = new Array(layoutMatrix[0].length).fill(-1);
            }
          }
        }
      }
      return layoutMatrix;
    },
    syncMatrixWithLayoutReverse() {
      for (let i = this.layoutMatrix.length - 1; i >= 0; i--) {
        if (typeof this.layoutMatrix[i] !== 'undefined') {
          for (let j = this.layoutMatrix[i].length - 1; j >= 0; j--) {
            if (this.layoutMatrix[i][j] !== -1) {
              let index = this.findLayoutIndexById(this.layoutMatrix[i][j])
              this.layout[index].x = j * 3;
              this.layout[index].y = i;
            }
          }
        }

      }
    },
    syncMatrixWithFormulas() {
      let lastVal = -1;
      for (let i = 0; i < this.layoutMatrix.length; i++) {
        if (typeof this.layoutMatrix[i] !== 'undefined') {
          for (let j = 0; j < this.layoutMatrix[i].length; j++) {
            if (lastVal !== -1 && this.layoutMatrix[i][j] === lastVal) {
              lastVal = this.layoutMatrix[i][j];
              continue;
            }
            let index = this.findIndexInFormulas(this.layoutMatrix[i][j]);
            if (index !== -1) {
              this.localFormulas[index].pivot.position_x = j * 3;
              this.localFormulas[index].pivot.position_y = i;
            }
            lastVal = this.layoutMatrix[i][j];
          }
        }
      }
    },
    findCustomFormula(name, spacename) {
      for (let i = 0; i < this.formulas.length; i++) {
        let formulaName = this.formulas[i].name.toLowerCase();
        let formulaSpacename = this.formulas[i].pivot.spacename.toLowerCase();
        if (formulaName === name.toLowerCase() && formulaSpacename === spacename.toLowerCase()) {
          return this.formulas[i];
        }
      }
      return false;
    },
    findInFormulas(id) {
      let expandCount = 0;
      let videoCount = 0;
      for (let i = 0; i < this.formulas.length; i++) {
        let iNum = 0;
        if (this.formulas[i].name === 'expand_sum') {
          iNum = 'e-' + this.formulas[i].id + '-' + expandCount;
          expandCount++;
        } else if (this.formulas[i].name === 'video_sum') {
          iNum = 'v-' + this.formulas[i].id + '-' + videoCount;
          videoCount++;
        } else {
          iNum = this.formulas[i].id;
        }
        if (iNum === id) {
          return this.formulas[i];
        }
      }
      return {};
    },
    findIndexInFormulas(id) {
      let expandCount = 0;
      let videoCount = 0;
      for (let i = 0; i < this.formulas.length; i++) {
        let iNum = 0;
        if (this.formulas[i].name === 'expand_sum') {
          iNum = 'e-' + this.formulas[i].id + '-' + expandCount;
          expandCount++;
        } else if (this.formulas[i].name === 'video_sum') {
          iNum = 'v-' + this.formulas[i].id + '-' + videoCount;
          videoCount++;
        } else {
          iNum = this.formulas[i].id;
        }
        if (iNum === id) {
          return i;
        }
      }
      return -1;
    },
    async saveDashboard(clickedFromHeader) {
      try {
        clickedFromHeader ? this.$root.$emit('dashboardLoader', true) : this.savingDashboard = true;
        await CampaignRepository.updateComment(this.campaignId, {comment: this.comment === null || this.comment === '' ? this.vuexStateComment : this.comment});
        let formulas = [];
        let customFormulas = [];
        for (let i = 0; i < this.layout.length; i++) {
          let layout = this.layout[i];
          let formula = this.findInFormulas(this.layout[i].i);
          if (formula.name === 'expand_sum' || formula.name === 'video_sum') {
            formula = this.findCustomFormula(formula.pivot.name, formula.pivot.spacename);
            customFormulas.push(formula.pivot.name + '-' + formula.pivot.spacename);
          }
          formula.pivot.position_x = this.layout[i].x;
          formula.pivot.position_y = this.layout[i].y;
          formula.pivot.chart_width = this.layout[i].w;
          formula.pivot.visibility = layout.visibility;
          formula.pivot.comment = typeof this.layout[i].comment !== 'undefined' ? this.layout[i].comment : '';
          formulas.push(formula);
        }
        for (let i = 0; i < this.formulas.length; i++) {
          if (this.formulas[i].id === 1 && this.formulas[i].name !== 'expand_sum' && this.formulas[i].name !== 'video_sum') {
            let formulaName = this.formulas[i].name;
            let formulaSpacename = this.formulas[i].pivot.spacename;
            if (customFormulas.indexOf(formulaName + '-' + formulaSpacename) === -1) {
              formulas.push(this.formulas[i]);
            }
          }
        }
        await TrackingListRepository.updateTrackingListFormula(this.formulas[0].pivot.tracking_list_id, {formulas: formulas});
        this.$noty.success('Erfolgreich gespeichert');
      } catch (e) {
        this.alert(e);
      }
      clickedFromHeader ? this.$root.$emit('dashboardLoader', false) : this.$root.$emit('saveDashboardFinished');
    },
    getCurrentBreakpoint() {
      let reload = false;
      if (window.innerWidth >= 1200) {
        if (this.currentBreakPoint !== 'lg') {
          reload = true;
        }
        this.currentBreakPoint = 'lg';
      } else if (window.innerWidth >= 996) {
        if (this.currentBreakPoint !== 'md') {
          reload = true;
        }
        this.currentBreakPoint = 'md';
      } else if (window.innerWidth >= 768) {
        if (this.currentBreakPoint !== 'sm') {
          reload = true;
        }
        this.currentBreakPoint = 'sm';
      } else if (window.innerWidth >= 480) {
        if (this.currentBreakPoint !== 'xs') {
          reload = true;
        }
        this.currentBreakPoint = 'xs';
      } else {
        if (this.currentBreakPoint !== 'xxs') {
          reload = true;
        }
        this.currentBreakPoint = 'xxs';
      }
      if (reload && this.layoutReady) {
        this.layoutReady = false;
        if (this.currentBreakPoint === 'xs' || this.currentBreakPoint === 'xxs') {
          this.colNum = 3;
          this.layoutMatrix = this.transformMatrix(1);
        } else if (this.currentBreakPoint === 'sm' || this.currentBreakPoint === 'md') {
          this.layoutMatrix = this.transformMatrix(2);
          this.colNum = 6;
        } else {
          this.layoutMatrix = this.transformMatrix(3);
          this.colNum = 9;
        }
        this.syncMatrixWithFormulas();
        this.loadLayout();
        this.layoutReady = true;
      }

    },
    listToMatrix(list, elementsPerSubArray) {
      let matrix = [], i, k;
      for (i = 0, k = -1; i < list.length; i++) {
        if (i % elementsPerSubArray === 0) {
          k++;
          matrix[k] = [];
        }
        matrix[k].push(list[i]);
      }
      if (matrix.length > 0) {
        while (matrix[matrix.length - 1].length !== elementsPerSubArray) {
          matrix[matrix.length - 1].push(-1);
        }
      } else {
        this.noData = true;
      }
      return matrix;
    },
    transformMatrix(colums) {
      this.noData = false;
      let list = [];
      for (let i = 0; i < this.layoutMatrix.length; i++) {
        if (typeof this.layoutMatrix[i] !== 'undefined') {
          list = list.concat(this.layoutMatrix[i]);
        }
      }
      list = [...new Set(list)];
      if (colums > 1) {
        for (let i = 0; i < list.length; i++) {
          if (list[i] !== -1 && this.findInFormulas(list[i]).pivot.chart_width === 6) {
            list.splice(i, 0, list[i]);
            i++;
          }
        }
      }
      for (let i = 0; i < list.length; i++) {
        if (list[i] === -1) {
          list.splice(i, 1);
          i--;
        }
      }
      let newMatrix = this.listToMatrix(list, colums);
      if (colums > 1) {
        newMatrix = this.correctMatrix(newMatrix);
      }
      return newMatrix;
    },
    correctMatrix(matrix) {
      let lastInLine = -1;
      let firstInLine = -1;
      for (let i = 0; i < matrix.length; i++) {
        firstInLine = matrix[i][0];
        if (firstInLine === lastInLine && lastInLine !== -1) {
          matrix = this.moveRightFromPosition(matrix, matrix[i - 1].length - 1, i - 1, 1);
          matrix[i - 1][matrix[i - 1].length - 1] = -1;
        }
        lastInLine = matrix[i][matrix[i].length - 1];
      }
      return matrix;
    },
    getVideoLabels(video) {
      let labels = [];
      if (typeof video['Video gestartet'] !== 'undefined') {
        labels.push('0 %');
      }
      if (typeof video['Video 25% gesehen'] !== 'undefined') {
        labels.push('25 %');
      }
      if (typeof video['Video 50% gesehen'] !== 'undefined') {
        labels.push('50 %');
      }
      if (typeof video['Video 75% gesehen'] !== 'undefined') {
        labels.push('75 %');
      }
      if (typeof video['Video 100% gesehen'] !== 'undefined') {
        labels.push('100 %');
      }
      return labels;
    },
    getVideoValues(video) {
      let values = [];
      if (typeof video['Video gestartet'] !== 'undefined') {
        values.push(this.getCount(video['Video gestartet']));
      }
      if (typeof video['Video 25% gesehen'] !== 'undefined') {
        values.push(this.getCount(video['Video 25% gesehen']));
      }
      if (typeof video['Video 50% gesehen'] !== 'undefined') {
        values.push(this.getCount(video['Video 50% gesehen']));
      }
      if (typeof video['Video 75% gesehen'] !== 'undefined') {
        values.push(this.getCount(video['Video 75% gesehen']));
      }
      if (typeof video['Video 100% gesehen'] !== 'undefined') {
        values.push(this.getCount(video['Video 100% gesehen']));
      }
      return values;
    },
    getCount(reporting) {
      let count = 0;
      let hash_key = this.engagementHash + '_' + this.insertionOrder.id;
      for (let i = 0; i < reporting.reporting[hash_key].sites.length; i++) {
        for (let j = 0; j < reporting.reporting[hash_key].sites[i].sites.length; j++) {
          let site = typeof reporting.reporting[hash_key].sites[i].sites[j].parent_name !== 'undefined' && reporting.reporting[hash_key].sites[i].sites[j].parent_name ? reporting.reporting[hash_key].sites[i].sites[j].parent_name + ' ' + reporting.reporting[hash_key].sites[i].sites[j].name : reporting.reporting[hash_key].sites[i].sites[j].name;
          if (this.sites.indexOf(site) !== -1) {
            let tmp = reporting.reporting[hash_key].sites[i].sites[j].count;
            if (typeof tmp === 'string' && tmp.indexOf('s') !== -1) {
              tmp = parseFloat(tmp.replace('s', ''));
            }
            count += tmp;
          }
        }
      }
      return count;
    },
    getRelation(reporting) {
      let count = 0;
      let relation = 0;
      let hash_key = this.engagementHash + '_' + this.insertionOrder.id;
      for (let i = 0; i < reporting.reporting[hash_key].sites.length; i++) {
        for (let j = 0; j < reporting.reporting[hash_key].sites[i].sites.length; j++) {
          let site = typeof reporting.reporting[hash_key].sites[i].sites[j].parent_name !== 'undefined' && reporting.reporting[hash_key].sites[i].sites[j].parent_name ? reporting.reporting[hash_key].sites[i].sites[j].parent_name + ' ' + reporting.reporting[hash_key].sites[i].sites[j].name : reporting.reporting[hash_key].sites[i].sites[j].name;
          if (this.sites.indexOf(site) !== -1) {
            let relationTmp = reporting.reporting[hash_key].sites[i].sites[j].relation.replace('%', '');
            relationTmp = parseFloat(relationTmp.replace(',', '.'));
            relation += relationTmp;
            count++;
          }
        }
      }
      if (count > 0) {
        relation = (relation / count).toFixed(2).toLocaleString('de-DE').replace(".", ",") + ' %';
      } else {
        relation = '0,00 %';
      }
      return relation;
    }
  }
}
</script>

<style scoped lang="scss">
.gridLayout {
  margin-right: -15px;
  margin-left: -15px;
}

.chart {
  margin-top: 1rem;
  display: inline-block;
  height: 100%;
  width: 100%;
  text-align: center;
  background-color: #fff;
}

.chart-header {
  font-weight: bold;
  padding: 1rem;
  height: 3rem;
  position: absolute;
  width: 100%;
}

.chart-header-text {
  float: left;
  font-size: 1em;
}

.chart-wrapper {
  padding-left: 15px;
  margin-top: 3rem;
}

.modal-container {
  padding: 2.1em !important;
}

.textarea-comment {
  width: 90%;
}

@media (max-width: 767px) {
  .gridLayout {
    margin-right: -30px;
    margin-left: -30px;
  }

  canvas {
    width: 100%;
    height: 100%;
  }
}

.no-data {
  display: block;
  width: 12rem;
  margin: auto;
  padding-top: 3rem;
  font-weight: bold;
}

.loaderContainer {
  display: flex;
  justify-content: center;
  align-items: center;
  width: 100%;
  height: 10em;
}

</style>